import { createPinia } from "pinia";
import { createApp } from "vue";
import App from "./App.vue";
import { initEventListeners } from "./game/events.js";
import { startGameLoop } from "./game/gameLoop.js";
import { hasSave, loadGame, saveGame } from "./game/saveSystem.js";
import router from "./router";
import { useGameStore } from "./stores/gameStore.js";
import { useInventoryStore } from "./stores/inventoryStore.js";

window.DEBUG = true;

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.mount("#app");

const game = useGameStore();
const inventory = useInventoryStore();

initEventListeners(game, inventory);

const loaded = hasSave() && loadGame();
if (!loaded) {
  game.initPlayer();
  game.startFight();
}

startGameLoop();

setInterval(saveGame, 60000);

window.addEventListener("beforeunload", saveGame);
